import React, { useRef, useState } from 'react';
import { FaImage } from 'react-icons/fa';
import useEditorStore from '../../store/editorStore';
import { frameStyles } from '../../config/constants';
import ImageEditorModal from '../modals/ImageEditorModal';
import './ImageBlock.css';

function ImageBlock({ block }) {
  const fileInputRef = useRef(null);
  const { updateBlock } = useEditorStore();
  const [showEditor, setShowEditor] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        updateBlock(block.id, { content: event.target.result });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleDoubleClick = (e) => {
    e.stopPropagation();
    setShowEditor(true);
  };

  // Get selected frame style
  const selectedFrame = frameStyles.find(s => s.id === block.styles.frameStyle) || frameStyles[0];
  const frameStyle = selectedFrame.style || {};

  const styles = {
    width: '100%',
    height: '100%',
    objectFit: block.styles.objectFit || 'cover',
    objectPosition: `${50 + (block.styles.offsetX || 0)}% ${50 + (block.styles.offsetY || 0)}%`,
    transform: `scale(${(block.styles.zoom || 100) / 100})`,
    // If using a frame, let the frame handle border radius via overflow:hidden on wrapper
    // Unless it's 'none' or 'simple' where we might want manual control? 
    // For now, let's apply manual radius to the image only if frame is 'none'
    borderRadius: block.styles.frameStyle && block.styles.frameStyle !== 'none' ? '0' : `${block.styles.borderRadius}px`,
    filter: `brightness(${block.styles.brightness || 100}%) contrast(${block.styles.contrast || 100}%) blur(${block.styles.blur || 0}px) saturate(${block.styles.saturation || 100}%) grayscale(${block.styles.grayscale || 0}%) sepia(${block.styles.sepia || 0}%) hue-rotate(${block.styles.hueRotate || 0}deg)`,
  };

  const wrapperStyle = {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...frameStyle
  };

  // If manual border radius is set and we are in 'simple' or 'none' mode, we might want to apply it to wrapper too?
  // But for simplicity, let's stick to the frame definitions for now.
  // If the user wants custom radius, they use 'none' and the slider.

  const handleUpdate = (sectionId, itemId, newSettings) => {
    // sectionId is null for blocks, itemId is block.id
    // We need to map the settings back to block styles
    updateBlock(block.id, {
      styles: {
        ...block.styles,
        ...newSettings
      }
    });
  };

  return (
    <>
      <div className="image-block" style={wrapperStyle}>
        {block.content ? (
          <img
            src={block.content}
            alt="Block content"
            style={styles}
            onDoubleClick={handleDoubleClick}
          />
        ) : (
          <div className="image-placeholder" onClick={handleClick} style={{width: '100%', height: '100%'}}>
            <FaImage size={48} />
            <span>คลิกเพื่ออัปโหลดรูปภาพ</span>
          </div>
        )}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
      </div>
      
      {showEditor && (
        <ImageEditorModal
          item={{
            id: block.id,
            ...block.styles,
            imageUrl: block.content // Modal expects imageUrl
          }}
          sectionId={null} // Not used for blocks
          onClose={() => setShowEditor(false)}
          onUpdate={handleUpdate}
        />
      )}
    </>
  );
}

export default ImageBlock;
